<template>
  <CRow>
    <CCol col="12" lg="12">
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>
        {{ err_msg }}
      </CAlert>
      <CCard>
        <CCardHeader>
          <strong>{{ $lang.instituteChain.crud.create }}</strong>
        </CCardHeader>
        <CForm novalidate @submit.prevent="onSubmit">
          <CCardBody>
            <CRow>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.bodyName.$error }">
                  <label class="form__label">Body Name
                    <required_span />
                  </label>
                  <input type="text" placeholder="Name" class="form-control"
                    v-model="instituteChain.bodyName" />
                  <small class="error" v-if="$v.instituteChain.bodyName.$error && !$v.instituteChain.bodyName.required">{{
        $lang.instituteChain.validation.required.bodyName }}</small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.description.$error }">
                  <label class="form__label">Description
                    <required_span />
                  </label>
                  <input type="text" placeholder="Name" class="form-control"
                    v-model="instituteChain.description" />
                  <small class="error" v-if="$v.instituteChain.description.$error && !$v.instituteChain.description.required">{{
        $lang.instituteChain.validation.required.description }}</small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.address.$error }">
                  <label class="form__label">Address
                    <required_span />
                  </label>
                  <input type="text" placeholder="Name" class="form-control"
                    v-model="instituteChain.address" />
                  <small class="error" v-if="$v.instituteChain.address.$error && !$v.instituteChain.address.required">{{
        $lang.instituteChain.validation.required.address }}</small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.website.$error }">
                  <label class="form__label">Alumni Website
                    <required_span />
                  </label>
                  <input type="text" placeholder="Name" class="form-control"
                    v-model="instituteChain.website" />
                  <small class="error" v-if="$v.instituteChain.website.$error && !$v.instituteChain.website.required">{{
        $lang.instituteChain.validation.required.website }}</small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.website.$error }">
                  <label class="form__label">Membership ID Prefix
                    <required_span />
                  </label>
                  <input type="text" placeholder="Name" class="form-control"
                    v-model="instituteChain.prefix" />
                  <small class="error" v-if="$v.instituteChain.website.$error && !$v.instituteChain.website.required">{{
        $lang.instituteChain.validation.required.website }}</small>
                </div>
              </CCol>
              <CCol md="6">
                <div class="form-group" :class="{ 'form-group--error': $v.instituteChain.email.$error }">
                  <label class="form__label">Email
                    <required_span />
                  </label>
                  <input type="text" placeholder="Email" class="form-control"
                    v-model="instituteChain.email" />
                  <small class="error" v-if="$v.instituteChain.email.$error && !$v.instituteChain.email.required">{{
        $lang.instituteChain.validation.required.email }}</small>
                  <small class="error" v-if="$v.instituteChain.email.$error && !$v.instituteChain.email.email">{{
        $lang.instituteChain.validation.email.email }}</small>
                </div>
              </CCol> 
              <CCol md="6">
                  <div
                      class="form-group"
                      :class="{
                      'form-group--error': $v.instituteChain.mobileNumber.$error,
                    }"
                  >
                    <label class="form__label"
                    >Mobile Number
                      <required_span
                      />
                    </label>
                    <vue-tel-input
                        v-model="instituteChain.mobileNumber"
                        v-on:country-changed="countryChanged"
                        v-bind="bindProps"
                        class="form-control"
                    ></vue-tel-input>
                    <small
                        class="error"
                        v-if="
                        $v.instituteChain.mobileNumber.$error &&
                        !$v.instituteChain.mobileNumber.required
                      "
                    >{{ $lang.instituteChain.validation.required.mobileNumber }}</small
                    >
                  </div>
                </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <div class="form-group" :class="{ 'form-group--error': '' }">
                  <img :src="SRCIMAGE" v-if="SRCIMAGE" alt="Profile Image"/>
                  <ImageCropper @profileImage="getProfile($event)"/>
                </div>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton type="submit" size="sm" color="primary" :disabled="submitted">
              <CIcon name="cil-check-circle" />
              {{ $lang.buttons.general.crud.submit }}
            </CButton> &nbsp;
            <CButton color="danger" size="sm" @click="cancel">
              <CIcon name="cil-ban" />
              {{ $lang.buttons.general.crud.cancel }}
            </CButton>
          </CCardFooter>
        </CForm>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import ImageCropper from "../ImageCropper";
import { instituteChain, users, company, country, state, city } from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import { required } from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueToasted from "vue-toasted";
import VueTelInput from "vue-tel-input-fix";
import "vue-tel-input-fix/dist/vue-tel-input.css";

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
Vue.use(VueTelInput);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "instituteChainCreate",
  mixins: [Mixin],
  components: {
    required_span,
    ImageCropper,
  },
  data() {
    return {
      SRCIMAGE: null,
      moduleCountry: country,
      moduleState: state,
      moduleCity: city,
      imageRemove: null,
      bindProps: {
        mode: "international",
        placeholder: "Contact No.",
        defaultCountry: "IN",
        dropdownOptions: {
          showFlags: true,
        },
        validCharactersOnly: true,
      },
      submitted: false,
      amountField: true,
      persontageField: false,
      userField: true,
      companyField: true,
      companyDropdwonField: true,
      err_msg: "",
      dismissCountDown: 0,
      self: this,
      module: instituteChain,
      instituteChain: {
        imageURL: "",
        mobileNumber:"",
        mobileNumberCode: "",
        bodyName:"",
        description:"",
        address:"",
        website:"",
        email:"",
        prefix:"",
      },
    };
  },
  validations: {
    instituteChain: {
      bodyName: {
        required,
      },
      description: {
        required,
      },
      address: {
        required,
      },
      mobileNumber: {
        required,
      },
      website: {
        required,
      },
      email: {
        required,
      },
    },
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    self.dismissCountDown = 0;
  },
  methods: {
    getProfile(profile) {
      let self = this;
      self.instituteChain.imageURL = profile;
      if (profile === "") {
        self.instituteChain.imageRemove = 1;
      } else {
        self.instituteChain.imageRemove = 0;
      }
    },
    countryChanged(country) {
      let self = this;
      self.instituteChain.mobileNumberCode = "+" + country.dialCode;
      let mobile = self.instituteChain.mobileNumber;
      self.instituteChain.mobileNumber = mobile
        .replace("+" + country.dialCode, "")
        .trim();
    },
    loadState() {
      let self = this;
      const postData = { countryId: self.instituteChain.country.value };
      self.instituteChain.state = {}; //reset
      axios
        .post(this.listUrlApi(this.moduleState), postData)
        .then((response) => {
          self.StateOptions = [];
          response.data.data.map(function (value, key) {
            self.StateOptions.push({ value: value.id, label: value.name });
          });
        });
    },
    loadCity() {
      let self = this;
      const postData = { stateId: self.instituteChain.state.value };
      self.instituteChain.city = {}; //reset
      axios
        .post(this.listUrlApi(this.moduleCity), postData)
        .then((response) => {
          self.cityOptions = [];
          response.data.data.map(function (value, key) {
            self.cityOptions.push({ value: value.id, label: value.name });
          });
        });
    },
    sendAlert() {
      this.$root.$emit("alert", "test1", "test2");
    },
    onSubmit() {
      let self = this;
      this.$v.instituteChain.$touch();
      if (this.$v.instituteChain.$invalid) {
        self.submitted = false;
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true;
        this.submitStatus = "PENDING";
        setTimeout(() => {
          let self = this;
          const formData = new FormData();
          formData.append("image", self.instituteChain.imageURL);
          formData.append("bodyName", self.instituteChain.bodyName);
          formData.append("description", self.instituteChain.description);
          formData.append("address", self.instituteChain.address);
          formData.append("website", self.instituteChain.website);
          formData.append("email", self.instituteChain.email);
          formData.append("prefix", self.instituteChain.prefix);
          formData.append("mobileNumber", self.instituteChain.mobileNumber);
          formData.append("mobileNumberCode", self.instituteChain.mobileNumberCode);
          axios.post(this.createUrlWeb(this.module), formData)
            .then(function (response) {
              self.submitted = false;
              if (response.data.code === 200) {
                localStorage.setItem("showAlert", "This is my alert");
                self.sendAlert();
                self.$router.push({ path: "/institute-chain" });
              } else {
                self.err_msg = response.data.response.message;
                self.dismissCountDown = 10;
              }
            })
            .catch(function (error) {
              let data;
              if (error.response.data.error) {
                data = error.response.data.error.toString();
              } else {
                data = error.response.data.message;
              }
              self.err_msg = data;
              self.dismissCountDown = 10;
              self.submitted = false; //Enable Button
            });
        }, 500);
      }
    },
    cancel() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/instituteChain" });
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
